import React, { useEffect } from "react";
import "./successNotification.css";

export default function SuccessNotification({
  open,
  message,
  onClose,
  duration = 4000,
}) {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [open, onClose, duration]);

  if (!open) return null;

  return (
    <div className="success-notification">
      <div className="success-notification-content">
        <svg
          className="success-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span className="success-message">{message}</span>
        <button className="success-close" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
}
